import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLocation = function SvgLocation(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M11.077 1.481c-3.563.375-6.469 3.188-6.984 6.75-.282 2.156.234 4.125 1.359 5.719l5.719 8.203c.375.562 1.219.562 1.64 0l5.72-8.203c.89-1.313 1.452-2.86 1.452-4.547-.047-4.734-4.125-8.484-8.906-7.922zm.89 11.906a3.981 3.981 0 01-3.984-3.984 3.981 3.981 0 013.985-3.984 3.981 3.981 0 013.984 3.984 3.981 3.981 0 01-3.984 3.984z"
  }));
};

export default SvgLocation;